import {isEmpty} from 'lodash';
import React, {FC, useMemo} from 'react';

import {Trans} from '../../../../../../libs/shared/helpers/src/internationalization/react';
import {HandlerOf} from '../../../../../../libs/shared/helpers/src/react/reactHelpers';
import {sortCustomAttributes} from '../../../../../helpers/customFieldHelpers';
import {CustomAttributeModel, CustomFieldModel} from '../../../../../models/api/customFieldModel';
import {ConversationCustomAttribute} from './conversationCustomAttribute';
import {StyledEmptyDiv} from './conversationSummaryCommonStyles';
import {ConversationSummarySectionsEnum} from './conversationSummarySections';

interface ConversationSummaryCustomAttributesProps {
  className?: string;
  conversationId: number;
  customAttributes: ReadonlyArray<CustomAttributeModel>;
  unsavedCustomAttributes: ReadonlyArray<CustomAttributeModel>;
  onDiscardUnsavedCustomAttribute: HandlerOf<CustomFieldModel>;
}

export const ConversationSummaryCustomAttributes: FC<ConversationSummaryCustomAttributesProps> = (props) => {
  const {
    className,
    conversationId,
    customAttributes,
    unsavedCustomAttributes,
    onDiscardUnsavedCustomAttribute,
  } = props;

  const sortedAttributes = useMemo(
    () => sortCustomAttributes([...customAttributes, ...unsavedCustomAttributes]),
    [customAttributes, unsavedCustomAttributes],
  );

  return (
    <div className={className} data-testid={ConversationSummarySectionsEnum.CUSTOM_ATTRIBUTES}>
      {renderCustomAttributesContent(sortedAttributes, conversationId, onDiscardUnsavedCustomAttribute)}
    </div>
  );
};

function renderCustomAttributesContent(
  customAttributes: ReadonlyArray<CustomAttributeModel>,
  conversationId: number,
  onDiscard: HandlerOf<CustomFieldModel>,
) {
  if (isEmpty(customAttributes)) {
    return (
      <StyledEmptyDiv>
        <Trans id="conversation-custom-attributes-empty">None</Trans>
      </StyledEmptyDiv>
    );
  }

  return customAttributes.map((customAttribute) => (
    <ConversationCustomAttribute
      key={customAttribute.customField.id}
      conversationId={conversationId}
      customAttribute={customAttribute}
      onValueDiscarded={() => onDiscard(customAttribute.customField)}
      onValueSaved={() => onDiscard(customAttribute.customField)}
    />
  ));
}
